module.exports = __webpack_public_path__ + "img/img2.7dff5964.png";